import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { animateScroll } from 'react-scroll';
import { Link } from 'react-router';
import Breadcrumbs from 'components/Breadcrumbs';
import Icon from 'components/Icon';
import Style from './InfoContainer.module.scss';

const InfoContainer = ({ breadcrumbsData, showName, showCode, children }) => {
  useEffect(() => {
    animateScroll.scrollToTop({ duration: 500 });
  }, []);

  return (
    <div className={Style.gridContainer}>
      <div className={Style.returnButtonContainer}>
        <Link className={Style.returnButton} to={`/${showCode}/`}>
          <Icon color="white" size="medium" viewBox="0 0 18 36" icon="ios-arrow-left" />
          {`Back to ${showName}`}
        </Link>
      </div>
      {children}
      <Breadcrumbs data={breadcrumbsData} customStyle={Style.breadcrumb} />
    </div>
  );
};

export default InfoContainer;

InfoContainer.defaultProps = {
  breadcrumbsData: {},
  showName: '',
  showCode: '',
  children: null,
};

InfoContainer.propTypes = {
  breadcrumbsData: PropTypes.arrayOf(PropTypes.shape({})),
  showName: PropTypes.string,
  showCode: PropTypes.string,
  children: PropTypes.node,
};
